import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import BillsOfLadingToolbar from '../components/toolbars/BillOfLadingListToolbar';
import '../index.css';

const BillsOfLadingList = () => {
    const [bills, setBills] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const navigate = useNavigate();

    useEffect(() => {
        fetchBills();
    }, []);

    const fetchBills = async () => {
        try {
            const response = await axios.get('/api/bills');
            const sortedBills = response.data.sort(
                (a, b) => new Date(b.shipDate) - new Date(a.shipDate)
            );
            setBills(sortedBills);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching Bills of Lading:', error);
            setLoading(false);
        }
    };

    const handleEdit = (bolID) => {
        navigate(`/bill-of-lading/${bolID}`);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentBills = bills.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(bills.length / itemsPerPage);

    const handleCreateNew = () => {
        navigate('/bill-of-lading');
    };

    if (loading) {
        return (
            <>
                <BillsOfLadingToolbar onCreateNew={handleCreateNew} />
                <div className="container mt-4">
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <BillsOfLadingToolbar onCreateNew={handleCreateNew} />
            
            <div className="container mt-4">
                <div className="card">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Ship Date</th>
                                        <th>Shipper</th>
                                        <th>Carrier</th>
                                        <th>Consignee</th>
                                        <th>Tax Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentBills.map((bill) => (
                                        <tr 
                                            key={bill.bolID}
                                            onClick={() => handleEdit(bill.bolID)}
                                            style={{ cursor: 'pointer' }}
                                            className="table-row-hover"
                                        > 
                                            <td>{bill.bolID}</td>
                                            <td>{new Date(bill.shipDate).toLocaleDateString()}</td>
                                            <td>{bill.shipperName}</td>
                                            <td>{bill.carrierName}</td>
                                            <td>{bill.consigneeName}</td>
                                            <td>
                                                <span className={`badge ${bill.bolTAX === 'PAID' ? 'bg-success' : 'bg-warning'}`}>
                                                    {bill.bolTAX}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Pagination Controls */}
                <div className="d-flex justify-content-center mt-4">
                    <nav aria-label="Page navigation">
                        <ul className="pagination">
                            <li 
                                className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}
                                onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                            >
                                <button className="page-link" type="button">Previous</button>
                            </li>
                            {[...Array(totalPages).keys()].map((page) => (
                                <li
                                    key={page}
                                    className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}
                                    onClick={() => setCurrentPage(page + 1)}
                                >
                                    <button className="page-link" type="button">
                                        {page + 1}
                                    </button>
                                </li>
                            ))}
                            <li 
                                className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}
                                onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                            >
                                <button className="page-link" type="button">Next</button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

            <style jsx>{`
                .table-row-hover:hover td {
                    background-color: rgba(0,0,0,.075);
                }
                .table-row-hover {
                    transition: background-color 0.2s ease;
                }
                .page-link {
                    cursor: pointer;
                }
                .page-item.disabled .page-link {
                    cursor: not-allowed;
                }
                .badge {
                    font-weight: normal;
                    font-size: 0.875rem;
                }
            `}</style>
        </>
    );
};

export default BillsOfLadingList;